<div ngbDropdown #dropDown="ngbDropdown" [display]="display" [autoClose]="autoClose" [open]="opened" [container]="container">
  <div
    class="form-control"
    tabIndex="0"
    [class.no-value]="!selectedOption?.id && selectedOption?.id !== 0"
    [attr.readonly]="disabled ? true : null"
    ngbDropdownAnchor
    (click)="toggle($event)">
    <span class="text-ellipsis">{{selectedOption?.name || placeholder}}</span>
  </div>
  <div class="dropdown-menu" ngbDropdownMenu>
    <div *ngIf="_options?.length > 10 || defaultSearch" class="search-input">
      <cm-search-input (valueDebouncedChange)="onSearch($event)" [minSearchLength]="1"></cm-search-input>
    </div>
    <ng-container *ngIf="_options?.length <= 1000">
      <ng-container *ngFor="let option of (search ? searchedOptions : _options); trackBy: trackbyFn">
        <ng-container
          [ngTemplateOutlet]="dropdownOptionTemplate"
          [ngTemplateOutletContext]="{ $implicit: option }"
        ></ng-container>
      </ng-container>
    </ng-container>
    <cdk-virtual-scroll-viewport *ngIf="_options?.length > 1000" minBufferPx="200" maxBufferPx="400" itemSize="40" class="dropdown-viewport">
      <ng-container *cdkVirtualFor="let option of (search ? searchedOptions : _options); trackBy: trackbyFn">
        <ng-container
          [ngTemplateOutlet]="dropdownOptionTemplate"
          [ngTemplateOutletContext]="{ $implicit: option }"
        ></ng-container>
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </div>
</div>

<ng-template #dropdownOptionTemplate let-option>
  <div
    *ngIf="!option.useHtml"
    (click)="selectValue(option)"
    class="option"
    [ngClass]="[
      selectedOption?.id === option.id ? 'selected-option' : '',
      selectedOption?.id !== option.id && option.disabled ? 'disabled-option' : '',
      option.customClass || ''
    ]"
  >{{option.name}}</div>
  <div
    *ngIf="option.useHtml"
    (click)="selectValue(option)"
    class="option"
    [ngClass]="[
      selectedOption?.id === option.id ? 'selected-option' : '',
      selectedOption?.id !== option.id && option.disabled ? 'disabled-option' : '',
      option.customClass || ''
    ]"
    [innerHTML]="option.htmlMarkup"
    container="body"
    placement="top-left"
    tooltipClass="max-400 text-left"
    [ngbTooltip]="option.tooltip"
  ></div>
</ng-template>
